import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import styled from "styled-components";
import { CloseIcon } from "../icons/CloseIcon";

const StyledPopoverTrigger = styled.div`
    position: relative;
`;

const StyledPopoverContent = styled.div`
    position: absolute;
    top: ${({ coords }) => coords.top + coords.height + 16}px;
    left: ${({ coords, contentWidth }) => window.innerWidth - coords.left > contentWidth ? coords.left : (coords.left - contentWidth + coords.width) }px;
    visibility: ${({visible, contentWidth}) => visible && contentWidth ? "visible" : "hidden"};
`;


const Popover = ({ content, children }) => {
    const defaultRect = {
        left: 0,
        top: 0,
        width: 0,
        height: 0
    };
    const [ visible, setVisible ] = useState(false);
    const [ triggerRect, setTriggerRect ] = useState(defaultRect);
    const [ contentWidth, setContentWidth ] = useState(0);
    const ref = useRef(null);
    const triggerRef = useRef(null);

    useLayoutEffect(() => {
        let element = ref.current;
        if (element === null) {
            return;
        };
        setContentWidth(element.getBoundingClientRect().width);
    }, []);

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (ref.current && !ref.current.contains(e.target) && triggerRef.current && !triggerRef.current.contains(e.target)) {
                setVisible(false);
            }
        };

        if (visible) {
            document.addEventListener("mousedown", handleOutsideClick, false);
        };

        return () => document.removeEventListener("mousedown", handleOutsideClick, false);
    }, [ visible ]);

    const onTriggerClick = (e) => {
        let element = triggerRef.current;
        if (element === null) {
            return;
        };
        setTriggerRect(element.getBoundingClientRect());
        setVisible(!visible);
    }

    return(<>
        <StyledPopoverTrigger onClick={onTriggerClick} id="popover-trigger" ref={triggerRef}>{children}</StyledPopoverTrigger>
        <StyledPopoverContent coords={triggerRect} contentWidth={contentWidth} ref={ref} visible={visible}>
            <CloseIcon size={24} style={{ position: "absolute", top: 8, right: 8 }} onClick={() => setVisible(false)} />
            {content}
        </StyledPopoverContent>
    </>);
};

export { Popover };